export const ACTIVE_CUSTOMER_REVIEW_STATUSES = new Set(["active", "customer"]);

export const normalizeCustomerReviewStatus = (value) =>
  String(value || "").trim().toLowerCase();

export const getCustomerReviewGate = (customerData, loading = false) => {
  if (loading) {
    return {
      loading: true,
      passed: false,
      status: "loading",
      title: "Customer Review",
      message: "Checking attached customer status before Purchase Orders can be generated.",
      tooltipMessage: "Customer review is still loading.",
      actionLabel: "",
      canRequestConversion: false,
    };
  }

  const status = normalizeCustomerReviewStatus(customerData?.status);
  if (ACTIVE_CUSTOMER_REVIEW_STATUSES.has(status)) {
    return {
      loading: false,
      passed: true,
      status: "active",
      title: "Customer Review",
      message: "Customer is active.",
      tooltipMessage: "",
      actionLabel: "Passed",
      canRequestConversion: false,
    };
  }

  if (status === "in-review") {
    return {
      loading: false,
      passed: false,
      status: "in-review",
      title: "Customer Review",
      message: "Customer conversion is currently awaiting review.",
      tooltipMessage:
        "Customer conversion is awaiting approval before Purchase Orders can be generated.",
      actionLabel: "Awaiting Review",
      canRequestConversion: false,
    };
  }

  if (status === "lead") {
    return {
      loading: false,
      passed: false,
      status: "lead",
      title: "Customer Review",
      message:
        "This account is still a Lead and must be converted to a Customer before Purchase Orders can be generated.",
      tooltipMessage:
        "Customer must be converted from Lead before Purchase Orders can be generated.",
      actionLabel: "Not Ready",
      canRequestConversion: true,
    };
  }

  return {
    loading: false,
    passed: false,
    status: status || "missing",
    title: "Customer Review",
    message: "A valid Customer must be attached before Purchase Orders can be generated.",
    tooltipMessage: "A valid Customer must be attached before Purchase Orders can be generated.",
    actionLabel: "Not Ready",
    canRequestConversion: false,
  };
};
